import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateLeaveRequestFrom {
  public type: number = 0;
  public firstApprover: string = '';
  public secondApprover: string = '';
  public dates: string[] = [];
  public notes: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    type: [
      (v: number) => !!v || 'Type is required',
    ],
    firstApprover: [
      (v: string) => !!v || 'First Approver is required',
    ],
    document: [
      (v: File) => !!v && Math.ceil(v.size / 1024) <= 10000 || 'Image size must be maximum 10mb',
      (v: File) => !!v && ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'].includes(v.type) || 'Invalid type! allowed are png, jpg, jpeg, pdf!',
    ],
  };
}

export class EditPaidLeavesForm {
  public paidLeaves: number = 0;
  public canUseAfter: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    paidLeaves: [
      (v: number) => !!v || 'Paid Leaves Count is required',
      (v: number) => v >= 0 || 'Paid Leaves Count Should be positive number',
    ],

    canUseAfter: [
      (v: string) => !!v || 'First Date is required',
    ],
  };
}

export class EditAdditionalPaidLeavesForm {
  public additionalPaidLeaves: number = 0;
  public isManager: boolean = false;

  public rules: { [key: string]: FormValidationFunction[] } = {
    additionalPaidLeaves: [
      (v: number) => !!v || 'Paid Leaves Count is required',
      (v: number) => v >= 0 || 'Paid Leaves Count Should be positive number',
    ],
  };
}
